import React, { Component } from 'react';
import './Servers.css';
import { bookingEngineStatus, emailStatus } from '../../services/status';

class Servers extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
      bookingEngineServer: undefined,
      emailsServer: undefined,
		};
  }
  
  componentDidMount() {
    this.getBookingEngineStatus();
    this.getEmailStatus();
  }

  async getBookingEngineStatus() {
    try {
      await bookingEngineStatus();
      this.setState({ bookingEngineServer: true });
    } catch (err) {
      console.error();
    }
  }

  async getEmailStatus() {
    try {
      await emailStatus();
      this.setState({ emailsServer: true });
    } catch (err) {
      console.error();
    }
  }

	render() {
		return (
			<div className="serversWrapper">
				{
          this.state.bookingEngineServer
            ? <p style={{ color: 'green' }}>Status booking engine: OK - Up and running <i className="el-icon-loading"></i></p>
            : <p style={{ color: 'red' }}>Status booking engine: ERROR - Server is down</p>
        }
        {
          this.state.emailsServer
            ? <p style={{ color: 'green' }}>Status email server: OK - Up and running <i className="el-icon-loading"></i></p>
            : <p style={{ color: 'red' }}>Status email server: ERROR - Server is down</p>
        }
			</div>
		)
	}
}

export default Servers;



// WEBPACK FOOTER //
// ./src/components/Servers/Servers.js